import {
  anUpdateTaxiiThreatIntelSource,
  aTaxiiFeed,
  aThreatIntelSource,
  mockUpdateTaxiiThreatIntelSourceOperationMutation,
  ThreatIntelSourceType,
} from '__generated__';

export const getUpdateTaxiiThreatIntelSourceMutation = ({
  name,
  description,
}) => {
  return mockUpdateTaxiiThreatIntelSourceOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(0), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        updateTaxiiThreatIntelSource: anUpdateTaxiiThreatIntelSource({
          data: aThreatIntelSource({
            id: '1',
            name: name,
            description: description,
            sourceType: ThreatIntelSourceType.Taxii,
            taxiiFeed: aTaxiiFeed({
              maxLookbackDays: 7,
              url: 'http://besttaxii.com/taxii-discovery-service',
            }),
            items: {
              hasNextPage: false,
              objects: [],
              __typename: 'ThreatIntelItemPage',
              total: 0,
            },
          }),
        }),
      })
    );
  });
};

export const handlers = [
  mockUpdateTaxiiThreatIntelSourceOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        updateTaxiiThreatIntelSource: anUpdateTaxiiThreatIntelSource(),
      })
    );
  }),
];
